import React from "react";
import { Col, Row, Statistic, Skeleton } from "antd";
import Card from "../../../blocks/Card/Card";

const AdminCards = ({ listData, loading, shouldHideCard }) => {
  return (
    <Row gutter={[12, 12]}>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 8 }}
        lg={{ span: 4 }}
        xl={{ span: 4 }}
        hidden={shouldHideCard.pending_not_submitted}
      >
        <Card title="Pending (Not Submitted)" className="device-health admin-stats-cards">
          {loading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            <Row gutter={16} type="flex" align="middle" style={{ textAlign: "center" }}>
              <Col span={24}>
                <Statistic value={listData?.pending_applications_count} />
              </Col>
            </Row>
          )}
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 8 }}
        lg={{ span: 5 }}
        xl={{ span: 5 }}
        hidden={shouldHideCard.awaiting_review}
      >
        <Card title="Awaiting Review" className="days-activity admin-stats-cards">
          {loading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            <Row gutter={16} type="flex" align="middle" style={{ textAlign: "center" }}>
              <Col span={24}>
                <Statistic value={listData?.inprocess_applications_count} />
              </Col>
            </Row>
          )}
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 8 }}
        lg={{ span: 5 }}
        xl={{ span: 5 }}
        hidden={shouldHideCard.information_required}
      >
        <Card title="Information Required" className="admin-stats-cards">
          {loading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            <Row gutter={16} type="flex" align="middle" style={{ textAlign: "center" }}>
              <Col span={24}>
                <Statistic value={listData?.information_required_count} />
              </Col>
            </Row>
          )}
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 5 }}
        xl={{ span: 5 }}
        hidden={shouldHideCard.approved}
      >
        <Card title="Approved" className="resolution-metrics admin-stats-cards">
          {loading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            <Row gutter={16} type="flex" align="middle" style={{ textAlign: "center" }}>
              <Col span={24}>
                <Statistic value={listData?.approved_count} />
              </Col>
            </Row>
          )}
        </Card>
      </Col>

      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 12 }}
        lg={{ span: 5 }}
        xl={{ span: 5 }}
        hidden={shouldHideCard.total_pqqs}
      >
        <Card title="Total PQQs" className="admin-stats-cards">
          {loading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : (
            <Row gutter={16} type="flex" align="middle" style={{ textAlign: "center" }}>
              <Col span={24}>
                <Statistic value={listData?.pqqs_raised} />
              </Col>
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default AdminCards;
